import { isAfter } from "shared/utils/date";
import type { PublicExplorerPage } from "shared/types/ExplorerPage";

export const isExplorerPageExpired = (
  explorerPage: Pick<PublicExplorerPage, "expiresAt"> | null | undefined,
): boolean => {
  if (!explorerPage) return false;
  return !!(explorerPage.expiresAt && isAfter(explorerPage.expiresAt));
};
